import { Component, ReactNode } from 'react';

interface IProps {
  children: (args: { error?: Error, resetError: () => void }) => ReactNode;
  errorKey?: unknown;
}

interface IState {
  error?: Error;
  errorKey?: unknown;
}

export default class ErrorBoundaryState extends Component<IProps, IState> {
  public static getDerivedStateFromProps(nextProps: IProps, prevState: IState) {
    // Clear the error if the error key changes. The error key is used to determine when we can reasonably
    // throw away the current error and attempt to re render children.
    if (nextProps.errorKey !== prevState.errorKey) {
      return { error: undefined, errorKey: nextProps.errorKey };
    }

    return null;
  }

  public constructor(props: IProps) {
    super(props);
    this.state = {}; // Initialized by getDerivedStateFromProps
  }

  public componentDidCatch(error: Error) {
    this.setState({ error });
  }

  public render() {
    const { resetError } = this;
    const { children } = this.props;
    const { error } = this.state;

    return children({ error, resetError });
  }

  private resetError = () => this.setState({ error: undefined });
}
